import React from 'react';
import { CheckIcon, BookIcon, NotebookPenIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://checkout.impulsodigitalx.shop/cart/45707755323553:1';
export function IncludesSection() {
  const tomos = ['Tomo 1: Fundamentos de la crianza Montessori', 'Tomo 2: Actividades Montessori de 0 a 2 años', 'Tomo 3: Actividades Montessori de 2 a 4 años', 'Tomo 4: Ambiente, rutinas y gestión emocional', 'Tomo 5: Propuestas avanzadas y planificación (3 a 6 años)'];
  const workbook = ['Registros de observación', 'Planificadores', 'Reflexiones guiadas', 'Herramienta práctica de acompañamiento'];
  return <section className="w-full bg-[#F5EDE4] py-16 px-4" data-id="element-139">
      <div className="max-w-4xl mx-auto" data-id="element-140">
        <h2 className="text-2xl sm:text-3xl font-bold text-[#5C4033] mb-12 text-center" data-id="element-141">
          📚 ¿QUÉ INCLUYE EXACTAMENTE?
        </h2>

        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-142">
          {/* Tomos */}
          <div className="bg-[#FDF8F3] rounded-2xl shadow-lg p-8 border border-[#E0D5C8]" data-id="element-143">
            <div className="flex items-center gap-3 mb-6" data-id="element-144">
              <BookIcon className="w-8 h-8 text-[#8B9E7E]" data-id="element-145" />
              <h3 className="text-xl font-bold text-[#5C4033]" data-id="element-146">
                📘 LOS 5 TOMOS COMPLETOS
              </h3>
            </div>
            <ul className="space-y-4 mb-6" data-id="element-147">
              {tomos.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-148">
                  <span className="flex-shrink-0 w-5 h-5 bg-[#8B9E7E] text-white rounded-full flex items-center justify-center mt-0.5" data-id="element-149">
                    <CheckIcon className="w-3 h-3" data-id="element-150" />
                  </span>
                  <span className="text-[#8B7355]" data-id="element-151">{item}</span>
                </li>)}
            </ul>
            <p className="text-sm text-[#8B7355]/80 italic border-t border-[#E0D5C8] pt-4" data-id="element-152">
              Todo explicado de forma clara, respetuosa y aplicable en la vida
              real.
            </p>
          </div>

          {/* Workbook */}
          <div className="bg-[#FDF8F3] rounded-2xl shadow-lg p-8 border border-[#E0D5C8]" data-id="element-153">
            <div className="flex items-center gap-3 mb-6" data-id="element-154">
              <NotebookPenIcon className="w-8 h-8 text-[#D4956A]" data-id="element-155" />
              <h3 className="text-xl font-bold text-[#5C4033]" data-id="element-156">
                📒 WORKBOOK IMPRIMIBLE PARA EL ADULTO
              </h3>
            </div>
            <ul className="space-y-4 mb-6" data-id="element-157">
              {workbook.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-158">
                  <span className="flex-shrink-0 w-5 h-5 bg-[#D4956A] text-white rounded-full flex items-center justify-center mt-0.5" data-id="element-159">
                    <CheckIcon className="w-3 h-3" data-id="element-160" />
                  </span>
                  <span className="text-[#8B7355]" data-id="element-161">{item}</span>
                </li>)}
            </ul>
            <p className="text-sm text-[#8B7355]/80 italic border-t border-[#E0D5C8] pt-4" data-id="element-162">
              Pensado para vos, no para el niño.
            </p>
          </div>
        </div>

        <div className="text-center" data-id="element-163">
          <a href={CHECKOUT_URL} className="inline-block bg-[#8B9E7E] hover:bg-[#6B8068] text-white text-lg font-bold py-4 px-8 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:scale-105" data-id="element-164">
            👉 ACCEDER CON DESCUENTO
          </a>
        </div>
      </div>
    </section>;
}